import React from 'react';
import { connect } from 'react-redux';
import KuposHelmet from '../../../common/KuposHelmet';
import HeroSection from '../../common/HeroSection/HeroSection';
import ThemeNineTitle from '../common/ThemeNineTitle';
import { KuposInput } from '../../../common';
import getIcons from '../../functions/getIcons/getIcons';

const ThemeNineContactScreen = props => {
  const operator = props.home && props.home.operator;
  return (
    <div className="themes-theme-nine-contact-screen">
      <KuposHelmet />

      {/* <div id="contact">
        <div className="new-container">
          <div className="heading">
            <h1>Contacto</h1>
          </div>
        </div>
      </div> */}

      <div style={{ position: 'relative', marginTop: -130 }}>
        <HeroSection
          // height={'30vh'}
          heroImage={getIcons('contactUsBanner')}
          title={'Contacto'}
          description={'Home / Contacto'}
        />
      </div>

      <ThemeNineTitle title={'Contáctanos'} />

      <div className="form-and-contact-info-section">
        <div className="form-container">
          <div className="form-section">
            <div className="contact-input-item">
              <div className="contact-input-label less-bold-text ">Nombre</div>
              <KuposInput
                type="text"
                placeholder="Ej. Pedro"
                inputOuterStyle={{ border: '1px solid #cccc' }}
                // className={'input-theme-nine'}
              />
            </div>

            <div className="contact-input-item ">
              <div className="contact-input-label less-bold-text ">Teléfono</div>
              <KuposInput
                type="text"
                placeholder="+56 9 0000 0000"
                inputOuterStyle={{ border: '1px solid #cccc' }}
                // className={'input-theme-nine'}
              />
            </div>

            <div className="contact-input-item">
              <div className="contact-input-label less-bold-text ">Email</div>
              <KuposInput
                type="email"
                placeholder="ejemplo@gmail.com"
                inputOuterStyle={{ border: '1px solid #cccc' }}
                // className={'input-theme-nine'}
              />
            </div>

            <div className="contact-input-item">
              <div className="contact-input-label less-bold-text ">Comentario</div>
              <KuposInput
                type="text"
                placeholder="Opcional"
                inputOuterStyle={{ border: '1px solid #cccc' }}
                // className={'input-theme-nine'}
              />
            </div>
            <div className="contact-input-item center ">
              <button
                class="btn submit-btn  bold-text"
                style={{
                  background:
                    operator &&
                    operator.color_codes &&
                    operator.color_codes.button_color &&
                    operator.color_codes.button_color,
                  color: 'white',
                  width: '100%',
                }}
              >
                ENVIAR
              </button>
            </div>
          </div>
        </div>
        <div className="contact-info-container">
          {/* <div className="contact-info">
              <div className="image">
                <img src={getIcons('contactHeadphoneBlue')} />
              </div>
              <div>
                <span className="bold-text">Call center:</span>
                <span> {operator && operator.phone_number && operator.phone_number}</span>
              </div>
            </div> */}
          <div className="contact-info">
            <div className="image">
              <img src={getIcons('contactMailBlue')} alt="" />
            </div>
            <div>
              <span className="bold-text">Escríbenos:</span>
              <span> {operator && operator.email && operator.email}</span>
              <div style={{ marginTop: '5px' }}>
                <span className="bold-text">Postulaciones:</span>
                <span> postulaciones@thaebus.com</span>
              </div>
            </div>
          </div>
          <div className="contact-info">
            <div className="image">
              <img src={getIcons('contactLocationBlue')} alt="" />
            </div>
            <div>
              <span className="bold-text">Casa matriz:</span>
              <span> {operator && operator.address && operator.address}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

export default connect(mapStateToProps, {})(ThemeNineContactScreen);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeNine/ThemeNinePages/ThemeNineContactScreen.js